import { Component, Input } from "@angular/core";
import { AlertIconType } from "./alert-icon";

@Component({
    standalone: true,
    selector: 'gene-alert-icon',
    templateUrl: './alert-icon.component.html',
    styleUrls: ['./alert-icon.component.css']
})
export class AlertIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
    @Input() type: AlertIconType = 'warning';
}